import { PromotionTypeRadioGroup } from '@bo-components/promotions/PromotionTypeRadioGroup';
import { useSearchParams } from 'react-router-dom';

export const PromotionFormSwitch = () => {
  const [searchParams] = useSearchParams();

  switch (searchParams.get('type')) {
    case 'DepositMatch':
      return <div>DepositMatch</div>;
    case 'FlashSale':
      return <div>FlashSale</div>;
    case 'FreeEntryPromotion':
      return <div>FreeEntryPromotion</div>;
    case 'PayoutBoost':
      return <div>PayoutBoost</div>;
    case 'ProtectedPlay':
      return <div>ProtectedPlay</div>;
    default:
      return <PromotionTypeRadioGroup />;
  }
};
